import {ChangeEvent, useEffect, useRef, useState} from "react";
import {MarketingTxt, PolicyDiv, PolicyTxt, PrivacyDiv, PrivacyTxt, RefundDiv} from "../../utils/policyUtils";
import {useLocation, useNavigate} from "react-router-dom";
import {appleLogin, googleLogin, kakaoLogin, requestToLoginOrRegistration} from "../../utils/socialAuth";
import "./join.css";
import { UserLoginOrRegistrationRequest } from "../../types";
import {useMembership} from "../../hooks/MembershipProvider/MembershipProvider";

const Join = () => {
	const ChkFormList = [
		{
			title: `(필수) 서비스 이용 약관`,
			label: `policy`,
			value: false,
			required:true,
			txt: PolicyDiv,
		},
		{
			title: `(필수) 개인 정보 수집 동의`,
			label: `privacy`,
			value: false,
			required:true,
			txt: PrivacyDiv,
		},
		{
			title: `(선택) 광고성 수신 동의`,
			label: `marketing`,
			value: false,
			required:false,
			txt: RefundDiv,
		}
	];
	const [policyChkState, setPolicyChkState] = useState(ChkFormList);
	const navigate = useNavigate();
	const {state} = useLocation();
	const {user} = state || {};

	const onHandleCheck = (ev: ChangeEvent<HTMLInputElement>) => {
		let {checked, name} = ev.target;
		let temp
		temp = policyChkState?.map(val => {
			if (name === 'allChk') {
				return {
					...val,
					value: checked,
				}
			} else {
				if (val?.label === name) {
					return {
						...val,
						value: checked,
					}
				}
				return val;
			}
			
		});
		setPolicyChkState(temp);
	}
	
	const onSubmit = async () => {

		let PolicyChk = policyChkState?.filter(obj => obj?.label === `policy`)[0].value;
		let PrivacyChk = policyChkState?.filter(obj => obj?.label === `privacy`)[0].value;
		let ServiceChk = policyChkState?.filter(obj => obj?.label === `marketing`)[0].value;

		if (!PolicyChk) {
			return alert(`서비스 이용 약관 체크해주세요`);
		}

		if (!PrivacyChk) {
			return alert(`개인 정보 수집 동의 체크해주세요`);
		}

		// 1. 백엔드에 전송
		const policy = {
			agree_privacy_policy: PolicyChk,             // 개인정보 처리 방침
			agree_terms_of_service: PrivacyChk,            // 서비스 이용 약관
			agree_marketing_information: ServiceChk,            // 광고문자 허용
		}

		const userLoginOrRegistrationRequest: UserLoginOrRegistrationRequest = {
			...user,
			...policy
		}

		const result = await requestToLoginOrRegistration(userLoginOrRegistrationRequest, navigate);
		console.log(result,'/[result------------------------------>]');
		
		// navigate(`/phone-verification`);
		console.log(user, '/[join.tsx--------------------------->]')
	}
	
	
	useEffect(() => {
		// 1.
		if(user) {
			// 마케팅 동의가 체크되어 있을경우
			console.log(`마케팅 동의가 체크 되어 있을경우`)
		}
	}, [user]);
	const allChkState = policyChkState.every(item => item?.value === true);
	const reqChkState = policyChkState?.filter(item => item?.required === true && item?.value === true).length === 2;
		
	return (
		<>
			<div className={`content_wrap join`}>
				<div className={`section_wrap`}>
					<div className={`sec sec_1`}>
						<h2 className={`h2 text-center`}>기억의 서랍을 이용하려면 동의가 필요해요.</h2>
					</div>
					<div className={`sec sec_2`}>
						<div className={`form-group flex items-center justify-end`}>
							<p className={`body1 label`}>전체동의</p>
							<div className={`checkbox-container`}>
								<input className={``} id={`allChk`} name="allChk" checked={allChkState} onChange={(e) => onHandleCheck(e)} type={`checkbox`}/>
								<label className={`body1 checkmark`} htmlFor={`allChk`}></label>
							</div>
						</div>
					</div>
					<div className={`sec sec_3`}>
						<ul className={`join_chk`}>
							{/*반복문 구간*/}
							{policyChkState?.map((obj, idx) => {
								return (
									<li key={idx} className={``}>
										<div className={`collapse_tit flex items-center justify-between`}>
											<div className={`body1`}>{obj?.title}</div>
											<div className={`checkbox-container`}>
												<input className={``} id={obj?.label} name={obj?.label} checked={obj?.value}
												       onChange={(e) => onHandleCheck(e)} type={`checkbox`}/>
												<label className={`body1 checkmark`} htmlFor={obj?.label}></label>
											</div>
										</div>
										<div className={`policy_box`}>
											<div className={`wrap`}>
												{obj?.txt()}
											</div>
										</div>
									</li>
								)
							})}
						</ul>
					</div>
					<div className={`sec`}>
						<button className={`btn-submit ${(reqChkState) ? `act`:``}`} disabled={!reqChkState} onClick={onSubmit}>동의하고 시작하기</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Join